import controller from './new/new.controller';

export default angular.module('mpdx.contacts.bulkActions.appeal', [controller]).name;
